import {
  UseMediaQueryOptions,
  useMediaQuery as useChakraMediaQuery,
} from '@chakra-ui/react-v2';

/** The same as Chakra's `useMediaQuery`, but with the SSR option defaulting to false so that it returns the correct value on the first render. */
export const useMediaQuery = (
  query: string | string[],
  options: UseMediaQueryOptions = {},
) => useChakraMediaQuery(query, { ssr: false, ...options });
